import React from 'react'
import './banner.css'
import home1 from './img/home1.png'
import home2 from './img/home2.png'
import home3 from './img/home3.png'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

function Banner() {

    return (
        <div className = 'banner'>
            <Carousel showArrows = {false} stopOnHover = {false} showThumbs = {false} showStatus = {false} infiniteLoop = {true} swipeable = {true} emulateTouch = {true}  autoPlay = {true} interval = {5000}>
                <div className = 'bannerDiv' id = 'bannerDivId' >
                    <div className = 'bannerImg'><img src = {home1} alt = 'banner1'/></div>
                    <div className = 'bannerDesc'>
                        <div className = 'bannerPos'><p>#1 TOP SKILL CREATIVITY</p></div>
                        <div className = 'bannerTopic'><p>AWESOME<br></br> REACTJS<br></br>WEB DESIGNS !!!</p></div>
                        <div className = 'bannerTopicDesc'><p>Reactjs and firebase along CSS</p></div>
                    </div>
                </div>
                <div className = 'bannerDiv' id = 'bannerDivId'>
                    <div className = 'bannerImg'><img src = {home2} alt = 'banner1'/></div>
                    <div className = 'bannerDesc'>
                        <div className = 'bannerPos'><p>#2 TOP SKILL HIGH-QUALITY</p></div>
                        <div className = 'bannerTopic'><p>SCALABLE<br></br>DJANGO<br></br>DATABASE !!!</p></div>
                        <div className = 'bannerTopicDesc'><p></p></div>
                    </div>
                </div>
                <div className = 'bannerDiv' id = 'bannerDivId'>
                    <div className = 'bannerImg'><img src = {home3} alt = 'banner1'/></div>
                    <div className = 'bannerDesc'>
                        <div className = 'bannerPos'><p>#3 TOP SKILL EFFICIENCY</p></div>
                        <div className = 'bannerTopic'><p>PYTHON<br></br>MACHINE<br></br>LEARNING !!!</p></div>
                        <div className = 'bannerTopicDesc'><p>Numpy, Pandas , Scikit-learn and (Seaborn & Matplotlib)</p></div>
                    </div>
                </div>
            </Carousel>
        </div>
    )
}

export default Banner
